import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { MatDialog, MatOption } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { SolicitudRegistroComponent } from 'src/app/plusd/plugins/solicitud-registro/solicitud-registro.component';
import { XsLoginComponent } from 'src/app/core/plugins/explorer/xs-login/xs-login.component';
import { CoreCommonService } from 'src/app/core/services/core-common.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import { XsMessageBoxComponent } from 'src/app/common/widgets/xs-message-box/xs-message-box.component';
import { ArchivoService } from 'src/app/plusd/services/archivo.service';
import { SolicitudService } from 'src/app/plusd/services/solicitud.service';

import { JwtService } from '../../../services/jwt.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { CorreoService } from 'src/app/plusd/services/correo.service';
import { JwtHelperInit } from 'src/app/common/helpers/JwtHelperInit';

import Swal from 'sweetalert2'
// import { LocalStorageService } from 'ngx-localstorage';
import { SsoService } from 'src/app/plusd/services/sso.service';

import { RecaptchaComponent } from 'ng-recaptcha';
import { Title } from '@angular/platform-browser';
import { XsComunicadoComponent } from '../xs-comunicado/xs-comunicado.component';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-xs-bienvenido',
  templateUrl: './xs-bienvenido.component.html',
  styleUrls: ['./xs-bienvenido.component.css']
})
export class XsBienvenidoComponent implements OnInit {

  mostrarCasilla: boolean = false;
  //yt = '<iframe width="450" height="585" style="overflow: hidden !important;" src="https://api-seguridad.sunat.gob.pe/v1/clientessol/eaa4d437-2d37-4d02-a388-ae97a38aad41/oauth2/login?originalUrl=https://e-renta.sunat.gob.pe/loader/recaudaciontributaria/declaracionpago/personas" frameborder="0"></iframe>';
  /**caselec = {
    usuario: "",
    clave: "",
    ruc: "12345678901",
    razonSocial: "",
  }*/
  mostrarLogin: boolean = false;
  rucEncontrado: boolean = false;

  urlVideo = "";

  ingresoLogin: boolean;
  subsector = '';
  estado = false;
  nombreSubsector = '';
  imagenFondo = '';
  // visible = false; // Old
  visible = true; // New
  casilla = false;
  borrarCookie = false;

  registro: boolean = false;
  titulo = "SSO2";

  solicitud: any = {};
  verificacion: any = {};
  datosUbigeo: any = {};

  listaTipoPersona = [];
  listaTipoDocumento = [];

  listaEstadoSolicitud = [];
  listaDepartamento = [];
  listaProvincia = [];
  listaDistrito = [];
  nrodocumentoValido = true;

  nombreArchivo: string;
  cargaArchivo: boolean = false;

  mostrarUbigeo: boolean = false;
  representanteLegal: boolean = false;
  nuevaBusqueda: boolean = false;
  botonNuevo: boolean = false;
  registroManual: boolean = false;
  bloquearCampo: boolean = false;
  enviarSolicitud: boolean = false;

  documentoLength: boolean = false;

  url: string = "";
  urlSafe: SafeResourceUrl;
  htmlString;
  idArchivo = 0;
  usuarioCrea = "";

  estadoSolicitud: string = "";
  correoPrincial: string;
  progress: boolean = false;
  cambiarClave: boolean = false;
  @ViewChild("formReg", { static: false }) myFormRegister: ElementRef;
  @ViewChild("formUpload", { static: false }) myFormUpload: ElementRef;
  @ViewChild("simpleInput", { static: false }) myFileInput: ElementRef;
  @ViewChild("iframeUpload", { static: false }) myIframeUpload: ElementRef;
  urlIframe: string;
  hkey: string = "";
  tiket: string = "";

  @ViewChild('captchaRef', { static: true }) captchaRef: RecaptchaComponent;
  recaptcha: string = "";
  login = { usuario: "", clave: "", urls: "" };
  clave = { actual: "", nueva: "", nueva2: "" };
  correo = "";
  vistaMain: boolean = false;
  vistaLogin: boolean = true;
  vistaLogin2: boolean = false;
  licenciaAceptado: boolean = false;
  mensaje: string = "";
  vercaptcha: boolean = false;
  intento = 0;
  maxintento = 3;
  desabilitado: boolean = true;

  mensajeLogin: string = "";
  vistacclave: boolean = false;
  constructor(
    private titleService: Title,
    public dialog: MatDialog,
    public coreCommonService: CoreCommonService,
    private cookieService: CookieService,
    public xsAppConfigService: XsAppConfigService,
    public solicitudService: SolicitudService,
    public archivoService: ArchivoService,
    public jwtService: JwtService,
    public sanitizer: DomSanitizer,
    public correoService: CorreoService,
    public jwtHelperInit: JwtHelperInit,
    // public localStorageService: LocalStorageService,
    public ssoService: SsoService,
    @Inject(DOCUMENT) document: any
  ) {
  }

  urls: string = null;
  ngOnInit() {
    this.intento = 0;
    this.urls = document.location.search;
    if (this.urls != "") {
      var logu = this.urls.substring(0, 7);
      //console.log(logu);
      if ("?logout" == "" + logu) {
        var user = localStorage.getItem("idUsuario");
        localStorage.clear();
        var ilogin = { usuario: user, clave: "", urls: this.urls };
        this.ssoService
          .getlogut(ilogin)
          .then(res => {
            if (res.data.valido) {
              if (res.data.mensaje != null) {
                location.href = res.data.mensaje;
              }
            }
          }).catch(e => {
            //alert('' + e);
            Swal.fire({
              title: 'Error!',
              html: ''+ e,
              icon: 'error',
              showCloseButton: true,
              showConfirmButton: false,
              customClass: {
                container: 'xs-swal-container-left',
              }
            })
          });
      }
      if ("?cclave" == "" + logu) {
        this.vistacclave = true;
        console.log("mostrando vista clave 1");
        this.ssoService.recuperarGui({ usuario: this.urls })
          .then(r1 => {
            console.log(r1);
            this.mensajeLogin = "" + r1.data.mensaje;

          })
          .catch(e => {
            //console.log("respuesta :--------> ", e);
            //alert('' + e);

            Swal.fire({
              title: 'Error!',
              html: ''+ e,
              icon: 'error',
              showCloseButton: true,
              showConfirmButton: false,
              customClass: {
                container: 'xs-swal-container-left',
              }
            })
          });
      }
    }
    var tokensso = "" + localStorage.getItem("tokensso");
    console.log("tokensso:"+tokensso);
    if (this.vistacclave) {
      //vista ver clave
      // console.log("mostrando vista clave 2");
      this.cambiarClave = false;
      this.ingresoLogin = false;
      this.vistaLogin = false;
      this.vistacclave = true;
    } else if (tokensso == "" || tokensso == "null" || tokensso == "undefined") {
      //Mostrar login
      this.cambiarClave = false;
      this.ingresoLogin = false;
      this.vistaLogin = true;
      this.vistacclave = false;
    } else {
      this.cambiarClave = false;
      this.ingresoLogin = true;
      this.vistaLogin = false;
      this.vistacclave = false;

      var iusuario = ""+localStorage.getItem("idUsuariosso");
      console.log("idUsuariosso:"+iusuario);
      if (iusuario == "" || iusuario == "null" || iusuario == "undefined") {
        //Mostrar login
        this.cambiarClave = false;
        this.ingresoLogin = false;
        this.vistaLogin = true;
        this.vistacclave = false;
      }else{
        var ilogin = { usuario: localStorage.getItem("idUsuariosso"), clave: "", urls: this.urls };
        this.ssoService
          .getconfirm(ilogin)
          .then(res => {
            localStorage.setItem("mensaje", res.data.mensaje);
            if (res.data.confirm != null) {
              this.ssoService.confirm(res.data.confirm, {
                eIdUsuario: localStorage.getItem("idUsuariosso"),
                uCodUsuario: localStorage.getItem("usuario"), uNombreCompleto: localStorage.getItem("nombresso"),
                token: localStorage.getItem("tokensso"), tipoPersona: localStorage.getItem("tipoPersona"),
                numDocumento: localStorage.getItem("numDocumento")
              })
                .then(r1 => {
                  location.href = res.data.urls + r1.data.mensaje;
                })
                .catch(e => {
                  //console.log("respuesta :--------> ", e);
                  //alert('' + e);
  
                  Swal.fire({
                    title: 'Error!',
                    html: ''+ e,
                    icon: 'error',
                    showCloseButton: true,
                    showConfirmButton: false,
                    customClass: {
                      container: 'xs-swal-container-left',
                    }
                  })
  
                });
            } else {
              this.vistaLogin = false;
              this.ingresoLogin = true;
            }
          })
          .catch(e => {
            //console.log("respuesta :--------> ", e);
            //alert('' + e);
  
            Swal.fire({
              title: 'Error!',
              html: ''+ e,
              icon: 'error',
              showCloseButton: true,
              showConfirmButton: false,
              customClass: {
                container: 'xs-swal-container-left',
              }
            })
          });


      }


      
    }
    
  }

  onClickIngreso() {
    this.vistaMain = false;
    this.vistaLogin = true;
  }

  buscarIntentos(event) {
    this.mensajeLogin = "";
    this.desabilitado = true;
    this.vercaptcha = false;
    this.ssoService.intento({
      usuario: this.login.usuario
    })
      .then(r1 => {
        //console.log(r1);
        this.desabilitado = false;
        this.intento = r1.data.numero;
        if (this.intento > 0) {
          this.vercaptcha = true;
          this.mensajeLogin = "" + r1.data.mensaje;
          if (this.intento >= this.maxintento) {
            this.mensajeLogin += ". Usuario Bloqueado temporalmente. Intentelo en " + r1.data.tiempo + " minutos.";
            this.desabilitado = true;
          }
        }
      })
      .catch(e => {
        //console.log("respuesta :--------> ", e);
        //alert('' + e);

        Swal.fire({
          title: 'Error!',
          html: ''+ e,
          icon: 'error',
          showCloseButton: true,
          showConfirmButton: false,
          customClass: {
            container: 'xs-swal-container-left',
          }
        })
      });
  }

  mostrarDialogoXsLogin(params) {
    const dialogRef = this.dialog.open(XsLoginComponent, {
      width: '450px',
      height: '100px',
      panelClass: 'xs-dlg-base',
      disableClose: true,
      data: params
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.estado == 'ACEPTAR') {
        this.ingresoLogin = true;
      }
    });
  }

  mostrarMensajeDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-message-box-dlg",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }

  mostrarAlertaDialog(mensaje) {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "620px",
      panelClass: "xs-dlg-base",
      data: { titulo: "SSO", mensaje: mensaje, icono: "XS_IDEA" }
    });
  }

  mostrarMessageBox2(titulo, mensaje): void {
    const dialogRef = this.dialog.open(XsMessageBoxComponent, {
      width: "400px",
      panelClass: "xs-dlg-base",
      data: { titulo: titulo, mensaje: mensaje }
    });

    dialogRef.afterClosed().subscribe(resultado => {
    });
  }

  // TEMP (Puede usarse a futuro)
  onClickCerrarSesion() {
    let plusdSesionToken = this.cookieService.get('plusdSesionToken');
    this.cookieService.deleteAll();
    localStorage.clear();
    /*if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
      window.location.href = this.coreCommonService.APPLICATION_APP_HOST;
    } else {
      window.location.href = "" + window.location;
    }*/
    window.location.href = "" + window.location;
  }

  resolved(captchaResponse: string) {
    this.recaptcha = captchaResponse;
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  showSwal(title, text, icon) {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      showCloseButton: true,
      showConfirmButton: false,
    })
  }

  showSwalA(title, text, icon) {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      width: 650,
      showCloseButton: false,
      showConfirmButton: true,
      confirmButtonText: "ACEPTAR"
    });
  }



  onClickVerRecuperar() {
    this.vistaLogin = false;
    this.ingresoLogin = false;
    this.cambiarClave = true;
    this.vistacclave = false;
    this.mensajeLogin = "";
    this.mensaje = "";
  }


  onClickRegresar() {
    this.cambiarClave = false;
    this.ingresoLogin = false;
    this.vistacclave = false;
    this.vistaLogin = true;
  }


  buscarCorreo(event) {

    this.mensajeLogin = "";
    this.desabilitado = true;
    if (this.esEmailValido(this.correo)) {
      this.ssoService.validarCorreo({ usuario: this.correo })
        .then(r1 => {
          //console.log(r1);
          this.mensajeLogin = "" + r1.data.mensaje;
          if (r1.data.numero > 0) {
            this.desabilitado = false;
          }
        }).catch(e => {
          //console.log("respuesta :--------> ", e);
          //alert('' + e);
          Swal.fire({
            title: 'Error!',
            html: ''+ e,
            icon: 'error',
            showCloseButton: true,
            showConfirmButton: false,
            customClass: {
              container: 'xs-swal-container-left',
            }
          })


        });
    } else {
      //alert("Correo No valido");
      Swal.fire({
        title: 'Error!',
        html: 'Correo No Valido',
        icon: 'error',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          container: 'xs-swal-container-left',
        }
      })

    }
  }

  esEmailValido(email: string): boolean {
    //console.log(email);
    let mailValido = false;
    var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (email.match(EMAIL_REGEX)) {
      mailValido = true;
    }
    //console.log(mailValido);
    return mailValido;
  }

  onClickEnviarCorreo() {
    this.mensajeLogin = "";
    this.desabilitado = true;
    if (this.esEmailValido(this.correo)) {
      this.ssoService.enviarCorreo({ usuario: this.correo })
        .then(r1 => {
          //console.log(r1);
          //this.mensajeLogin = ""+r1.data.mensaje;
          if (r1.data.numero > 0) {
            //this.desabilitado = false;
            //alert("Se ha enviado su correo electronico para la modificacion de su contraseña.");

            Swal.fire({
              title: "Conforme",
              text: "Se ha enviado su correo electronico para la modificacion de su contraseña.",
              icon: 'success',
              showCloseButton: true,
              showConfirmButton: false,
            })

            this.onClickRegresar();
          } else {
           // alert(r1.data.mensaje);
            Swal.fire({
              title: 'Error!',
              html: r1.data.mensaje,
              icon: 'error',
              showCloseButton: true,
              showConfirmButton: false,
              customClass: {
                container: 'xs-swal-container-left',
              }
            })
          }
        })
        .catch(e => {
          console.log("respuesta :--------> ", e);
          //alert('' + e);
          Swal.fire({
            title: 'Error!',
            html: ''+ e,
            icon: 'error',
            showCloseButton: true,
            showConfirmButton: false,
            customClass: {
              container: 'xs-swal-container-left',
            }
          })

        });
    } else {
      //alert("Correo No valido");
      Swal.fire({
        title: 'Error!',
        html: 'Correo No valido',
        icon: 'error',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          container: 'xs-swal-container-left',
        }
      })
    }
  }

  onClickRestaurar() {
    this.mensajeLogin = "";
    if (this.validarClave()) {
      this.ssoService.restaurar({ usuario: this.clave.actual, clave: this.clave.nueva, urls: this.urls })
        .then(r1 => {
          if (r1.data.numero > 0) {
            //alert();
            Swal.fire({
              title: "Conforme",
              text: "Contraseña Actualizada correctamente",
              icon: 'success',
              showCloseButton: true,
              showConfirmButton: false,
            })
            location.href = "/sso2-front"
          }
        })
        .catch(e => {
          //console.log("respuesta :--------> ", e);
          //alert('' + e);
          Swal.fire({
            title: 'Error!',
            html: ''+ e,
            icon: 'error',
            showCloseButton: true,
            showConfirmButton: false,
            customClass: {
              container: 'xs-swal-container-left',
            }
          })
        });
    } else {
      //alert(this.mensaje);
      Swal.fire({
        title: 'Error!',
        html: this.mensaje,
        icon: 'error',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          container: 'xs-swal-container-left',
        }
      })
    }

  }

  validarClave() {
    if (this.clave.actual == null) {
      this.mensaje = "Ingrese Contraseña Actual";
      return false;
    }
    if (this.clave.actual.trim() == "") {
      this.mensaje = "Ingrese Contraseña Actual";
      return false;
    }
    if (this.clave.nueva == null) {
      this.mensaje = "Ingrese Contraseña Nueva";
      return false;
    }
    if (this.clave.nueva.trim() == "") {
      this.mensaje = "Ingrese Contraseña Nueva";
      return false;
    }
    if (this.clave.nueva.length < 8 || this.clave.nueva.length > 25) {
      this.mensaje = "La nueva Contraseña debe tener entre 8 a 25 caracteres";
      return false;
    }
    if (this.clave.nueva2 == null) {
      this.mensaje = "Ingrese Contraseña Nueva Repetida";
      return false;
    }
    if (this.clave.nueva2.trim() == "") {
      this.mensaje = "Ingrese Contraseña Nueva Repetida";
      return false;
    }
    if (this.clave.nueva != this.clave.nueva2) {
      this.mensaje = "Las Contraseñas nuevas no coinciden";
      return false;
    }

    return true;
  }
  loginValido(): boolean {
    let hasError = false;
    let msg = "";
    if (!this.login.usuario) {
      hasError = true;
      msg += "Codigo Usuario no puede estar vacío" + "<br>";
    }
    if (!this.login.clave) {
      hasError = true;
      msg += "Contraseña no puede estar vacío" + "<br>";
    }
    if (this.vercaptcha) {
      if (!this.recaptcha) {
        hasError = true;
        msg += "Selecciona el captcha" + "<br>";
      }
    }
    /* if (!this.recaptcha) {
       hasError = true;
       msg += "Selecciona el captcha" + "<br>";
     }*/

    if (hasError) {
      Swal.fire({
        title: 'Error!',
        html: msg,
        icon: 'error',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          container: 'xs-swal-container-left',
        }
      })
      return false
    }

    return true;
  }
  onClickIniciarSesion() {
    // IMP
    if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
      this.ingresoLogin = true;
      this.vistaLogin = false;
    } else {
      let check = this.loginValido();
      if (check) {
        if (this.xsAppConfigService.APLICACION_AMBIENTE == 'localhost-nologin') {
          this.ingresoLogin = true;
          this.vistaLogin = false;
        } else {
          this.login.urls = this.urls;
          this.ssoService.autenticar(this.login).then(res => {
            this.mensaje = res.data.mensaje;
            localStorage.setItem("mensaje", this.mensaje);
            localStorage.setItem("tokensso", res.data.token);
            localStorage.setItem("nombresso", res.data.nombre);
            localStorage.setItem("observacion", res.data.observacion);
            localStorage.setItem("estado", res.data.estado);
            localStorage.setItem("idUsuario", res.data.idUsuario);
            localStorage.setItem("idUsuariosso", res.data.idUsuario);
            localStorage.setItem("usuario", res.data.usuario);
            localStorage.setItem("tipoPersona", res.data.tipoPersona);
            localStorage.setItem("numDocumento", res.data.numDocumento);

            switch (res.data.estado) {
              case "ACCESO_PERMITIDO":
                if (res.data.confirm != null) {
                  this.ssoService
                    .confirm(res.data.confirm, {
                      eIdUsuario: localStorage.getItem("idUsuariosso"),
                      uCodUsuario: localStorage.getItem("usuario"), uNombreCompleto: localStorage.getItem("nombresso"),
                      token: localStorage.getItem("tokensso"), tipoPersona: localStorage.getItem("tipoPersona"),
                      numDocumento: localStorage.getItem("numDocumento")
                    })
                    .then(r1 => {
                      console.log(r1);
                      location.href = res.data.urls + r1.data.mensaje;
                    })
                    .catch(e => {
                      //console.log("respuesta :--------> ", e);
                      //alert('' + e);
                      Swal.fire({
                        title: 'Error!',
                        html: ''+ e,
                        icon: 'error',
                        showCloseButton: true,
                        showConfirmButton: false,
                        customClass: {
                          container: 'xs-swal-container-left',
                        }
                      })
                    });
                } else {
                  this.vistaLogin = false;
                  this.ingresoLogin = true;
                }
                break;
              case "ACCESO_DENEGADO":
                console.log("ACCESO_DENEGADO");
                //alert(localStorage.getItem("observacion"));
                this.buscarIntentos(null);
                Swal.fire({
                  title: 'Error!',
                  html: localStorage.getItem("observacion"),
                  icon: 'error',
                  showCloseButton: true,
                  showConfirmButton: false,
                  customClass: {
                    container: 'xs-swal-container-left',
                  }
                })
                break;
              default:
                break;
            }
          });
        }
      }
    }
  }
}
